import * as z from "zod/v4";

export const configureMerchantEmail = {
  name: "configureMerchantEmail" as const,
  input: z.object({ email: z.string().email(), name: z.string().min(1) }),
  output: z.object({
    redirectEmail: z.string(),
    dkimHost: z.string(),
    dkimText: z.string(),
    returnPathDomain: z.string(),
    returnPathValue: z.string(),
    setupStatus: z.string(),
  }),
};
